import { combineReducers } from 'redux';
import stepReducers from './StepReducers';
import FormReducers from './FormReducers';
import QuestionReducers from './QuestionReducers';
import ConsumerFormReducers from './ConsumerFormReducers';

export default combineReducers({
    currentStep: stepReducers,
    formValues: FormReducers,
    questionOptions: QuestionReducers,
    consumerFormActive: ConsumerFormReducers,
});